/**
 * Asynchronously loads the component for NewProgram
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
